export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_LEADERBOARD = 'FETCH_LEADERBOARD'
export const FETCH_LEADERBOARD_ERROR = 'FETCH_LEADERBOARD_ERROR'
